jQuery(document).ready(function ($) {
    const dropdown_labels = $('.mobile-menu__navigation--label').find('.dropdown');

    function toggleMobileSubnav (event) {
        $(this).toggleClass('active');
        $(this).parent().next().slideToggle(500);
    }

    dropdown_labels.on('click', toggleMobileSubnav);
});